<template>
    <div class="w-full">
        <PageHeader type="Playlist" :title="playlist.name">
            <template #art>
                <div class="h-44 w-44 overflow-hidden rounded-lg bg-nomad-800 shadow-lift sm:h-48 sm:w-48 lg:h-56 lg:w-56">
                    <ArtworkImage v-if="singleImage" :src="singleImage" :title="playlist.name" class="h-full w-full" />
                    <div v-else-if="mosaic.length >= 4" class="grid h-full w-full grid-cols-2">
                        <img v-for="src in mosaic.slice(0, 4)" :key="src" :src="src" alt="" class="h-full w-full object-cover" />
                    </div>
                    <span v-else class="flex h-full w-full items-center justify-center text-5xl text-nomad-500"><span class="icon-music"></span></span>
                </div>
            </template>
            <template #meta>
                <span class="inline-flex flex-wrap items-center gap-x-1.5">
                    <template v-if="playlist.type === 'user' && playlist.user">
                        <img v-if="playlist.user.image" :src="playlist.user.image" :alt="playlist.user.name" class="h-6 w-6 rounded-full object-cover" />
                        <span class="font-semibold text-white">{{ playlist.user.name }}</span>
                        <span v-if="playlist.songs_count > 0" class="mx-1">·</span>
                    </template>
                    <template v-else><span class="font-semibold text-white">Heesify</span><span v-if="playlist.songs_count > 0" class="mx-1">·</span></template>
                    <span v-if="playlist.songs_count > 0">{{ playlist.songs_count }} {{ playlist.songs_count === 1 ? 'song' : 'songs' }}</span>
                </span>
            </template>
            <template #actions v-if="playlist.songs && playlist.songs.length">
                <button type="button" class="nl-play-fab h-14 w-14 text-xl" @click="playFirst" aria-label="Play">
                    <span class="icon-play translate-x-0.5"></span>
                </button>
            </template>
        </PageHeader>

        <TrackList v-if="playlist.songs && playlist.songs.length" :songs="playlist.songs" :ad-after="[4, 24]" header />
        <p v-else class="py-16 text-center text-nomad-400">No songs in this playlist yet.</p>
    </div>
</template>
<script setup>
defineProps({ playlist: Object });
</script>
<script>
import { defineAsyncComponent } from 'vue'
import { mapState, mapActions } from "vuex";
import { usePage, Link } from "@inertiajs/vue3";
import CardSong from '@/components/CardSong.vue'
import ArtworkImage from "@/components/ui/ArtworkImage.vue";
import PageHeader from "@/components/ui/PageHeader.vue";
import TrackList from "@/components/ui/TrackList.vue";
export default {
    computed: {
        // A collage of four isn't one picture to open
        singleImage() {
            if (this.playlist.cover) return this.playlist.cover;
            return this.mosaic.length && this.mosaic.length < 4 ? this.mosaic[0] : null;
        },
        mosaic() {
            const covers = (this.playlist.songs || []).map((song) => song.cover || song.artist?.image).filter(Boolean);
            return [...new Set(covers)];
        },
    },
    methods: {
        ...mapActions("playlist", ["getSinglePlaylist"]),
        playFirst() {
            const song = this.playlist.songs[0];
            this.$store.dispatch('current/prepareCurrent', { id: song.id, type: 'SONG', name: song.name || song.title });
        },
    },
    beforeMount() {
        document.title = this.playlist.name + ' Heeso - Playlist'
    },
    components: {
        ArtworkImage,
        CardSong,
        PageHeader,
        TrackList,
    }
};
</script>